import React, { Component, Fragment } from 'react'
import './PerformanceRow.css'
//volatility table

class StdRiskRow extends Component {
  formatPercent(number) {
    return number !== null ? `${parseFloat(number * 100).toFixed(2)}%` : '-'
  }

  formatDate(string) {
    return new Date(string).toLocaleDateString([], { timeZone: 'UTC' })
  }
  render() {
    const { fund } = this.props

    if (fund.stdRisk === null) {
      return null
    }

    //const inceptionDate = new Date(fund.inceptionDate).toLocaleDateString()
    const hide = true
    return (
      <Fragment>
        <tr className='greyline'>
          <td width='70' className='textLeft'>
            {fund.type === 'BMK' || fund.type === 'BLEND' ? (
              fund.ticker.toUpperCase()
            ) : fund.fundPageURL ? (
              <a className='tickerLink' href={fund.fundPageURL} target='_new'>
                {fund.ticker}
              </a>
            ) : (
              <a className='tickerLink' href={fund.msUrl} target='_new'>
                {fund.ticker}
              </a>
            )}
          </td>
          {['BMK', 'WTIDX'].includes(fund.type) ? (
            <td width='300' className='textLeft'>
              {fund.name.replace(/&amp;/g, '&')}
            </td>
          ) : (
            <td width='300' className='textLeft'>
              {`${fund.name.replace(/&amp;/g, '&')} (NAV)`}
            </td>
          )}
          <td className='textCenter'>{this.formatDate(fund.inceptionDate)}</td>
          <td className='textCenter'>{this.formatPercent(fund.stdRisk.slice(-1)[0].yrs1NAV)}</td>
          <td className='textCenter'>{this.formatPercent(fund.stdRisk.slice(-1)[0].yrs3NAV)}</td>
          <td className='textCenter'>{this.formatPercent(fund.stdRisk.slice(-1)[0].yrs5NAV)}</td>
          <td className='textCenter'>{this.formatPercent(fund.stdRisk.slice(-1)[0].yrs10NAV)}</td>
          {fund.type === 'BMK' ? (
            <td className='textCenter'>
              -<br />
            </td>
          ) : (
            <td className='textCenter'>{this.formatPercent(fund.stdRisk.slice(-1)[0].inceptionNAV)}</td>
          )}
          <td className='textCenter'>{this.formatPercent(fund.stdRisk.slice(-1)[0].commonPeriodNAV)}</td>
        </tr>
        {!hide && (
          <tr className='whiteline'>
            <td className='textLeft'></td>
            <td className='textLeft'>{`${fund.name.replace(/&amp;/g, '&')} (MP)`}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdRisk.slice(-1)[0].yrs1MP)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdRisk.slice(-1)[0].yrs3MP)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdRisk.slice(-1)[0].yrs5MP)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdRisk.slice(-1)[0].yrs10MP)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdRisk.slice(-1)[0].inceptionMP)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdRisk.slice(-1)[0].commonPeriodMP)}</td>
          </tr>
        )}
      </Fragment>
    )
  }
}

export default StdRiskRow
